<template>
    <NuxtLink
        v-if="url"
        class="group active:text-base_black relative mr-4 mb-4 inline-flex h-12 items-center gap-1 rounded-[80px] px-6 py-3.5 leading-tight font-medium whitespace-nowrap transition-colors last:mb-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-40"
        :class="[buttonColor, $attrs.class]"
        :to="url"
        :target="isExternalLink(url) ? '_blank' : null"
        :title="title"
    >
        <BaseIcon
            v-if="icon && iconPosition === 'left' && !isExternalLink(url)"
            postnord-icon
            name="arrow-left"
            class="flex-shrink-0 transition-transform will-change-transform group-hover:-translate-x-1"
        />
        <span class="max-w-fit overflow-hidden text-ellipsis">{{ title }}</span>
        <BaseIcon
            v-if="icon && iconPosition === 'right' && !isExternalLink(url)"
            postnord-icon
            name="arrow-right"
            class="flex-shrink-0 transition-transform will-change-transform group-hover:translate-x-1"
        />
        <BaseIcon
            v-if="icon && iconPosition === 'right' && isExternalLink(url)"
            postnord-icon
            name="open-in-new"
            class="flex-shrink-0"
        />
    </NuxtLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { isExternalLink } from '../../utils/resolveLink';
import BaseIcon from './BaseIcon.vue';

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    size: {
        type: String as () => 'small' | 'medium',
        default: 'medium',
    },
    icon: {
        type: Boolean,
        default: false,
    },
    iconPosition: {
        type: String as () => 'left' | 'right',
        default: 'right',
    },
    bg: {
        type: String as () => 'light' | 'dark',
        default: 'light',
    },
});

const buttonColor = computed(() =>
    props.bg === 'dark'
        ? 'bg-transparent text-white border border-white hover:bg-black/15 hover:text-white dark-light active:text-white active:bg-black/90 focus-visible:outline-white'
        : 'bg-transparent text-black border border-black hover:bg-black/15 hover:text-black active:bg-grey-50 focus-visible:outline-black'
);
</script>
